import { render, staticRenderFns } from "./PhoneCaptureModal.vue?vue&type=template&id=1c610f69&scoped=true&lang=pug&"
import script from "./PhoneCaptureModal.vue?vue&type=script&lang=js&"
export * from "./PhoneCaptureModal.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCaptureModal.vue?vue&type=style&index=0&id=1c610f69&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c610f69",
  null
  
)

export default component.exports